export function parseProductDetailRows(value) {
  if (!value) return [];

  try {
    const rows = typeof value === 'string' ? JSON.parse(value) : value;
    if (!Array.isArray(rows)) return [];

    return rows
      .filter((row) => row && typeof row === 'object' && !Array.isArray(row))
      .map((row) => ({
        title: String(row.title || '').trim(),
        component: String(row.component || '').trim(),
      }))
      .filter((row) => row.title && row.component)
      .slice(0, 50);
  } catch (error) {
    return [];
  }
}

export function parseProductSellingPoints(value) {
  if (!value) return [];

  try {
    const points = typeof value === 'string' ? JSON.parse(value) : value;
    if (!Array.isArray(points)) return [];

    return points
      .map((point) => {
        if (point && typeof point === 'object' && !Array.isArray(point)) {
          return String(point.component || point.title || '').trim();
        }
        return String(point || '').trim();
      })
      .filter(Boolean)
      .slice(0, 50);
  } catch (error) {
    return [];
  }
}
